import React from "react";
import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Box,
  Spinner,
  useDisclosure,
} from "@chakra-ui/react";
import { MoreIcon } from "@root/assets/icons/MoreIcon";
import { JOURNALIST_STATUS } from "@root/constants";

const JournalistMenu = ({
  status,
  id,
  updateJournalistStatus,
  setDeleteModal,
  isLoading = false,
  t,
}: any) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const handleStatusUpdate = async (newStatus: number) => {
    onClose();
    await updateJournalistStatus(id, newStatus);
  };

  const handleDeleteClick = () => {
    onClose();
    setDeleteModal({ isOpen: true, id });
  };

  return (
    <Menu
      isLazy
      placement="bottom-end"
      isOpen={isLoading ? false : isOpen}
      onOpen={onOpen}
      onClose={onClose}
    >
      <MenuButton
        as={Box}
        cursor={isLoading ? "not-allowed" : "pointer"}
        onClick={(e) => {
          e.stopPropagation();
          if (isLoading) {
            e.preventDefault();
          }
        }}
      >
        {isLoading ? (
          <Spinner size="sm" color="#1819B4" />
        ) : (
          <MoreIcon
            fontSize="20px"
            color="#A3AED0"
            _hover={{ color: "#1819B4" }}
          />
        )}
      </MenuButton>
      <MenuList
        border={"1px solid #CDD6DC"}
        borderRadius={"12px"}
        boxShadow={"4px 4px 8px 0px #0000000F"}
        minW="160px"
        p={2}
      >
        {/* {status === JOURNALIST_STATUS.ACCEPTED && (
          <MenuItem
            px={3}
            py={2}
            borderRadius={"8px"}
            _hover={{ bg: "#CDD6DC3D", color: "#1819B4" }}
            icon={<></>}
            onClick={() =>
              updateJournalistStatus(id, JOURNALIST_STATUS.REJECTED)
            }
          >
            {t("journalistRequests.reject")}
          </MenuItem>
        )} */}
        {/* {status === JOURNALIST_STATUS.REJECTED && (
          <MenuItem
            px={3}
            py={2}
            borderRadius={"8px"}
            _hover={{ bg: "#CDD6DC3D", color: "#1819B4" }}
            icon={<></>}
            onClick={() =>
              updateJournalistStatus(id, JOURNALIST_STATUS.ACCEPTED)
            }
          >
            {t("journalistRequests.accept")}
          </MenuItem>
        )} */}
        {status === JOURNALIST_STATUS.PENDING && (
          <>
            <MenuItem
              px={3}
              py={2}
              borderRadius={"8px"}
              _hover={{ bg: "#CDD6DC3D", color: "#1819B4" }}
              icon={<></>}
              isDisabled={isLoading}
              onClick={() => handleStatusUpdate(JOURNALIST_STATUS.ACCEPTED)}
            >
              {t("journalistRequests.accept")}
            </MenuItem>
            <MenuItem
              px={3}
              py={2}
              borderRadius={"8px"}
              _hover={{ bg: "#CDD6DC3D", color: "#1819B4" }}
              icon={<></>}
              isDisabled={isLoading}
              onClick={() => handleStatusUpdate(JOURNALIST_STATUS.REJECTED)}
            >
              {t("journalistRequests.reject")}
            </MenuItem>
          </>
        )}
        <MenuItem
          px={3}
          py={2}
          borderRadius={"8px"}
          _hover={{ bg: "#CDD6DC3D", color: "#1819B4" }}
          icon={<></>}
          isDisabled={isLoading}
          onClick={handleDeleteClick}
        >
          {t("journalistRequests.delete")}
        </MenuItem>
      </MenuList>
    </Menu>
  );
};

export default JournalistMenu;
